import * as React from 'react'
import IconType from './iconType'

const PartnersIcon = (props: IconType) => {
  return (
    <svg
      className={`${props.className}`}
      height={props.h}
      width={props.w}
      viewBox="0 0 640 512"
      >
      <path d="M631.1 225.8l-122.9 71.48c-5.625 17.5-19.5 31.12-37.12 36.49v14.25c0 34.37-23.25 63.61-54.75 72.73c-9.249 34.12-40.5 59.23-77.37 59.23H224.1L172.5 509.9c-7.75 4.374-17.5 1.875-21.87-5.874L142.6 490.1c-4.375-7.748-1.875-17.5 5.875-21.87L211.3 431.9h128.6c17.87 0 32.25-14.37 32.25-32.12V375.8h24.12c15.25 0 27.75-12.5 27.75-27.87V287.9h31.1c4.375 0 7.1-3.624 7.1-7.998V247.9c0-4.374-3.625-7.998-7.1-7.998h-103.1v15.1c0 46.86-40.37 84.48-88.24 79.6c-41.75-4.249-71.75-42.49-71.75-84.23V209.1L159.6 228.7C149.9 234.4 144 244.9 144 256.3v61.73l-111.1 64.73c-7.75 4.374-17.5 1.75-21.87-5.998l-7.1-13.87c-4.375-7.623-1.875-17.5 5.875-21.87l87.99-50.74V256.2c0-28.24 14.75-54.36 38.87-68.86l59.37-35.49c4.625-20.49 16.1-38.49 35.25-49.86L263 81.09c17.75-11.12 38.25-16.1 59.25-16.1h92.74l108.7-61.98c7.625-4.374 17.37-1.75 21.75 5.998l7.875 13.87c4.375 7.748 1.75 17.37-5.1 21.87l-119.7 68.11h-105.4c-11.1 0-23.62 3.374-33.87 9.747L255 142.6C245.8 148.3 240 158.7 240 169.7v86.23c0 17.62 14.25 31.99 31.1 31.99c17.75 0 31.1-14.37 31.1-31.99V191.9h151.1c28.37 0 51.62 21.24 55.25 48.61l96.74-56.36c7.75-4.374 17.5-1.875 21.87 5.874l7.1 13.87C642.2 211.7 639.7 221.3 631.1 225.8z"
      />
    </svg>
  )
}

export default PartnersIcon
